// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-page[data-v-e994c038]  video {\n  width: 100% !important;\n}\n.box[data-v-e994c038] {\n  min-height: 100px;\n  padding: 10px;\n  background: #f5f5f5;\n}\n.box[data-v-e994c038]  img {\n  max-width: 100%;\n  height: auto;\n}", ""]);
// Exports
module.exports = exports;
